import PageLayout from "../../../../../components/page/PageLayout";
import OrdersLayout from "../../../account/layout/orders/OrdersLayout";

const PageOrders = () => {

    return (
        <PageLayout requireSignIn>
            <OrdersLayout />
        </PageLayout>
    )

}

export default PageOrders;
